"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildWebVitalCallback = void 0;
const buildWebVitalCallback = (name, buildParams) => (metric) => {
    if (__BUILD_TYPE__ !== 'online') {
        console.log(`[${name}]: `, metric);
    }
    const params = buildParams(metric);
    window.Tea('beaconEvent', `rd_web_vital_${name.toLowerCase()}`, params);
};
exports.buildWebVitalCallback = buildWebVitalCallback;
